import { useRef } from "react";

export const PathDots = ({ points, onSeek, onMove }) => {
  const drag = useRef(null);
  const down = (e, i) => {
    e.stopPropagation();
    e.currentTarget.setPointerCapture(e.pointerId);
    const r = e.currentTarget.parentElement.getBoundingClientRect();
    drag.current = { i, sx: e.clientX, sy: e.clientY, x0: points[i].x, y0: points[i].y, w: r.width, h: r.height };
    onSeek(i);
  };
  const move = (e) => {
    const d = drag.current;
    if (!d) return;
    const c = (v) => +Math.max(-1.5, Math.min(1.5, v)).toFixed(4);
    onMove(d.i, { x: c(d.x0 + ((e.clientX - d.sx) / d.w) * 2), y: c(d.y0 - ((e.clientY - d.sy) / d.h) * 2) });
  };
  const end = () => (drag.current = null);
  return points.map((k, i) => k && (
    <span key={i} onPointerDown={(e) => down(e, i)} onPointerMove={move} onPointerUp={end} onPointerCancel={end} onLostPointerCapture={end}
      data-testid={`fx-path-point-${i}`} title={`Keyframe ${i + 1} · drag to move`}
      className="absolute z-50 w-3 h-3 -ml-1.5 -mt-1.5 rounded-full bg-[#FFB800] border-2 border-[#0B0C10] cursor-grab active:cursor-grabbing hover:scale-125 transition-transform shadow-[0_0_8px_#FFB800]"
      style={{ left: `${50 + k.x * 50}%`, top: `${50 - k.y * 50}%` }} />
  ));
};
